export default "__VITE_ASSET__NEIgbnsS__"